// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__6iR+d","label":"style_label__v1KVU","tableWrap":"style_tableWrap__ATkAl","table":"style_table__UYFwm"};